// source: wisetime/user/assistant/v4/assistant.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.GenerateNarrativeRequest', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.GenerateNarrativeResponse', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.TranslateLanguage', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.Translation', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.GenerateNarrativeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.displayName = 'proto.wisetime.user.assistant.v4.GenerateNarrativeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.GenerateNarrativeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.displayName = 'proto.wisetime.user.assistant.v4.GenerateNarrativeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.displayName = 'proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.displayName = 'proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.Translation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.Translation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.Translation.displayName = 'proto.wisetime.user.assistant.v4.Translation';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.GenerateNarrativeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    unpostedTimeGroupId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.GenerateNarrativeRequest}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.GenerateNarrativeRequest;
  return proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.GenerateNarrativeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.GenerateNarrativeRequest}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnpostedTimeGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.GenerateNarrativeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnpostedTimeGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string unposted_time_group_id = 1;
 * @return {string}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.prototype.getUnpostedTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.assistant.v4.GenerateNarrativeRequest} returns this
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeRequest.prototype.setUnpostedTimeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.GenerateNarrativeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    narrativeList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    modelName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.GenerateNarrativeResponse}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.GenerateNarrativeResponse;
  return proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.GenerateNarrativeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.GenerateNarrativeResponse}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addNarrative(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.GenerateNarrativeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNarrativeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getModelName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated string narrative = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.prototype.getNarrativeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.assistant.v4.GenerateNarrativeResponse} returns this
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.prototype.setNarrativeList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.assistant.v4.GenerateNarrativeResponse} returns this
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.prototype.addNarrative = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.assistant.v4.GenerateNarrativeResponse} returns this
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.prototype.clearNarrativeList = function() {
  return this.setNarrativeList([]);
};


/**
 * optional string model_name = 2;
 * @return {string}
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.prototype.getModelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.assistant.v4.GenerateNarrativeResponse} returns this
 */
proto.wisetime.user.assistant.v4.GenerateNarrativeResponse.prototype.setModelName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    toLanguage: jspb.Message.getFieldWithDefault(msg, 1, 0),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.wisetime.user.assistant.v4.Translation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest;
  return proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.wisetime.user.assistant.v4.TranslateLanguage} */ (reader.readEnum());
      msg.setToLanguage(value);
      break;
    case 2:
      var value = new proto.wisetime.user.assistant.v4.Translation;
      reader.readMessage(value,proto.wisetime.user.assistant.v4.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.wisetime.user.assistant.v4.Translation.serializeBinaryToWriter
    );
  }
};


/**
 * optional TranslateLanguage to_language = 1;
 * @return {!proto.wisetime.user.assistant.v4.TranslateLanguage}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.prototype.getToLanguage = function() {
  return /** @type {!proto.wisetime.user.assistant.v4.TranslateLanguage} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.wisetime.user.assistant.v4.TranslateLanguage} value
 * @return {!proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest} returns this
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.prototype.setToLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated Translation translations = 2;
 * @return {!Array<!proto.wisetime.user.assistant.v4.Translation>}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.wisetime.user.assistant.v4.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.assistant.v4.Translation, 2));
};


/**
 * @param {!Array<!proto.wisetime.user.assistant.v4.Translation>} value
 * @return {!proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest} returns this
*/
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.wisetime.user.assistant.v4.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.assistant.v4.Translation}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.wisetime.user.assistant.v4.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest} returns this
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsRequest.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.wisetime.user.assistant.v4.Translation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse;
  return proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.assistant.v4.Translation;
      reader.readMessage(value,proto.wisetime.user.assistant.v4.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.assistant.v4.Translation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Translation translations = 1;
 * @return {!Array<!proto.wisetime.user.assistant.v4.Translation>}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.wisetime.user.assistant.v4.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.assistant.v4.Translation, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.assistant.v4.Translation>} value
 * @return {!proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse} returns this
*/
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.assistant.v4.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.assistant.v4.Translation}
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.assistant.v4.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse} returns this
 */
proto.wisetime.user.assistant.v4.BatchTranslateTextsResponse.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.Translation.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.Translation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.Translation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.Translation.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.Translation}
 */
proto.wisetime.user.assistant.v4.Translation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.Translation;
  return proto.wisetime.user.assistant.v4.Translation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.Translation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.Translation}
 */
proto.wisetime.user.assistant.v4.Translation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.Translation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.Translation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.Translation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.Translation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.wisetime.user.assistant.v4.Translation.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.assistant.v4.Translation} returns this
 */
proto.wisetime.user.assistant.v4.Translation.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.wisetime.user.assistant.v4.Translation.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.assistant.v4.Translation} returns this
 */
proto.wisetime.user.assistant.v4.Translation.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.wisetime.user.assistant.v4.TranslateLanguage = {
  TRANSLATE_LANGUAGE_UNSPECIFIED: 0,
  DUTCH: 1,
  ENGLISH: 2,
  FRENCH: 3,
  GERMAN: 4,
  SPANISH: 5
};

goog.object.extend(exports, proto.wisetime.user.assistant.v4);
